module.exports = __webpack_public_path__ + "static/img/project_2.7a2b2db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainPage/project_2.jpg
// module id = Je/N
// module chunks = 0